type RetryableCallStatus =
  | 'pending'
  | 'recording'
  | 'transcribing'
  | 'awaiting_summary'
  | 'summarizing'
  | 'complete'
  | 'failed'

export interface RetryCandidate {
  status: RetryableCallStatus
  audio_storage_path: string | null
  transcript: string | null
}

export type RetryTargetStatus = Extract<RetryableCallStatus, 'pending' | 'awaiting_summary'>

export interface RetryPatch {
  status: RetryTargetStatus
  error_message: null
  summary: null
  todos: []
  next_follow_date: null
  transcript?: null
}

export function getRetryTargetStatus(
  call: RetryCandidate
): RetryTargetStatus | null {
  if (call.status !== 'failed') return null
  if (call.audio_storage_path?.trim()) return 'pending'
  if (call.transcript && call.transcript.trim().length >= 20) return 'awaiting_summary'
  return null
}

export function buildRetryPatch(call: RetryCandidate): RetryPatch | null {
  const status = getRetryTargetStatus(call)
  if (!status) return null

  const base = {
    status,
    error_message: null,
    summary: null,
    todos: [],
    next_follow_date: null
  } satisfies RetryPatch

  if (status === 'pending') {
    return {
      ...base,
      transcript: null
    }
  }

  return base
}
